var EulaPackages = [
    'AGS Historical Package',
    'Canada - Census',
    'Canada - DEP',
    'Canada - HEP',
    'Nielsen Scarborough',
    'PRIZM',
    'PRIZM Canada'
];

export default EulaPackages;